module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_15.37dafdd3.pdf";